import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ArticoliPittogrammi } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class ArticoliPittogrammiService extends CrudGenericsService<ArticoliPittogrammi, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/ArticoliPittogrammi`);
    this.base = `${env.apiUrl}/api/ArticoliPittogrammi/`;
  }

  GetArticoliPittogrammi_ByArt(id: number): Observable<ArticoliPittogrammi[]> {
    const u = `${this.base}GetArticoliPittogrammi_ByArt?id=${id}`;
    return this.http.get<ArticoliPittogrammi[]>(`${u}`);
  }
}
